package world.phantasmal.psolib.fileFormats.quest

enum class Version {
    /**
     * Dreamcast
     */
    DC,

    /**
     * GameCube
     */
    GC,

    /**
     * Desktop
     */
    PC,

    /**
     * BlueBurst
     */
    BB,
}
